import {
    SET_STATUS

} from "./quizActions"

const initialState = {
     status: 0,

};

export const quizReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case SET_STATUS: {
            return {
                ...state,
                status: action.payload,
            };
        }
        default:
            return state;
    }
};

